// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3NnuY","open":"open___28CGR","header":"header___1lCQ5","card":"card___1DbiP","main":"main___zCtRj"};